import axios from '../request'
/**
 * 委托
 */

//投诉列表
export const getComplaintList = (params)=> axios.get("complaint/info",params);
//投诉详情
export const getComplaintDetail = (id)=> axios.get(`complaint/info/${id}`);

//发起投诉
export const AddComplaint = (params)=> axios.post("complaint/info",params);

